import { render } from "./SupportConsentCard.vue?vue&type=template&id=c224c5ec&scoped=true"
import script from "./SupportConsentCard.vue?vue&type=script&lang=js"
export * from "./SupportConsentCard.vue?vue&type=script&lang=js"

import "./SupportConsentCard.vue?vue&type=style&index=0&id=c224c5ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c224c5ec"],['__file',"src/views/components/SupportConsentCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c224c5ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c224c5ec', __exports__)) {
    api.reload('c224c5ec', __exports__)
  }
  
  module.hot.accept("./SupportConsentCard.vue?vue&type=template&id=c224c5ec&scoped=true", () => {
    api.rerender('c224c5ec', render)
  })

}


export default __exports__